<template>
  <div class="app" :class="{ 'is-videoresume': videoresume }">
    <template v-if="!isHidden && loaded && (response || error)">
      <component
        :is="way"
        :response-token="token"
        :response="response"
        :vcv-me-link="vcvMeLink"
        :error="error"
        @player_error="playerError"
      />

      <component :is="footerWay" v-if="getProcessName !== 'feniche'" :vcv-me-link="vcvMeLink" :vcv-link="vcvLink" />
    </template>

    <videoresume-stup v-if="isHidden && videoresume" :response="response" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import axios from 'axios';
import { load_script } from '@/_helpers/utils.js';
import Errors from '@/api/errors.json';
import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
import basic from './default.vue';
import basic_safari from './default_safari.vue';
import VideoresumeStup from './components/VideoresumeStup.vue';
import videoresume from './videoresume.vue';
import ResponseFooter from './components/ResponseFooter.vue';
import VideoresumeFooter from '@/components_new/b2c/vresume-footer/index.vue';
import PROCESS_NAMES from '@/process/names';

export default {
  name: 'PublicResponse',

  components: {
    default: basic,
    default_safari: basic_safari,
    videoresume,
    defaultFooter: ResponseFooter,
    videoresumeFooter: VideoresumeFooter,
    VideoresumeStup,
    ProcessFenichePublicResponse: () =>
      import('@/process/feniche/routes_new/outer/response/ProcessFenichePublicResponse')
  },

  mixins: [SafariBrowserDetector],

  props: ['token'],

  data() {
    return {
      loaded: false,
      videoresume: false,
      isHidden: false,
      response: null,
      error: null
    };
  },

  computed: {
    ...mapState(['locale']),

    ...mapGetters('process', ['getProcessName']),

    publicResponse() {
      return this.$store.getters['response/publicResponse'];
    },

    companyLang() {
      if (!this.publicResponse || !this.publicResponse.company || !this.publicResponse.company.language) {
        return null;
      }

      return this.publicResponse.company.language.code;
    },

    way() {
      if (this.videoresume) {
        return 'videoresume';
      } else {
        if (this.getProcessName !== undefined) {
          if (this.getProcessName === PROCESS_NAMES.FENICHE) {
            return 'process-feniche-public-response';
          }
        }
      }

      return 'default';
    },

    footerWay() {
      return this.videoresume ? 'videoresumeFooter' : 'defaultFooter';
    },

    vcvMeLink() {
      let lang = '';
      if (this.companyLang) {
        lang = this.companyLang;
      } else {
        lang = this.locale ? this.locale.value : 'en';
      }

      switch (lang) {
        case 'ru':
          return 'https://www.vcv.me/ru/';
        default:
          return 'https://www.vcv.me/';
      }
    },

    vcvLink() {
      const host = window.location.hostname;
      const hostArray = host.split('.');
      const domain = `${hostArray.slice(hostArray.length - 1)}`;

      switch (domain) {
        case 'ru':
          return 'https://www.vcv.ru/';
        default:
          return 'https://www.vcv.ai/';
      }
    }
  },

  beforeMount() {
    axios
      .get('/1.0/public-responses/' + this.token)
      .then(response => {
        // this.response = Object.assign({}, response.data.data[0], {
        //   is_candidate_link: true
        // });
        this.response = response.data.data[0];
        this.videoresume = this.response.is_candidate_link;
        this.isHidden = this.response.is_hidden;
        this.loaded = true;

        this.setMetrics();
      })
      .catch(err => {
        this.loading = true;
        this.error =
          handleError(err).message !== 'NETWORK_ERROR'
            ? handleError(err).message
            : this.$tr('common.error.networkError');
      });
  },

  methods: {
    playerError(ev) {
      let message = this.$tr('common.error');
      if (ev && ev.error_ && ev.error_.message) {
        message = ev.error_.message;
      }
      this.error = message;
    },

    setMetrics() {
      if (window.location.host === 'me.vcv.ai' && window.location.pathname === '/p/ccbfd578c6affa0ab61ab25fb008aff4') {
        // Ya counter
        (function (m, e, t, r, i, k, a) {
          m[i] =
            m[i] ||
            function () {
              (m[i].a = m[i].a || []).push(arguments);
            };
          m[i].l = 1 * new Date();
          (k = e.createElement(t)),
            (a = e.getElementsByTagName(t)[0]),
            (k.async = 1),
            (k.src = r),
            a.parentNode.insertBefore(k, a);
        })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

        ym(62911351, 'init', {
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true
        });

        // googletagmanager
        load_script(
          'https://www.googletagmanager.com/gtag/js?id=UA-165443544-10',
          'googletagmanager',
          () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              dataLayer.push(arguments[0]);
            }
            gtag('js', new Date());

            gtag('config', 'UA-165443544-10');
          },
          'defer'
        );

        //Facebook pixel
        // !(function(f, b, e, v, n, t, s) {
        //   if (f.fbq) return;
        //   n = f.fbq = function() {
        //     n.callMethod
        //       ? n.callMethod.apply(n, arguments)
        //       : n.queue.push(arguments);
        //   };
        //   if (!f._fbq) f._fbq = n;
        //   n.push = n;
        //   n.loaded = !0;
        //   n.version = '2.0';
        //   n.queue = [];
        //   t = b.createElement(e);
        //   t.async = !0;
        //   t.src = v;
        //   s = b.getElementsByTagName(e)[0];
        //   s.parentNode.insertBefore(t, s);
        // })(
        //   window,
        //   document,
        //   'script',
        //   'https://connect.facebook.net/en_US/fbevents.js'
        // );
        // fbq('init', '374957290302493');
        // fbq('track', 'PageView');
      }
    }
  }
};

function handleError(error) {
  const response = error.response;

  if (error.response) {
    if (!response.data || !response.data.meta || !response.data.meta.error) {
      return Errors['SERVER_ERROR'];
    }

    let error = response.data.meta.error;
    error.id = response.data.meta.id;
    error.status = response.status;

    return error;
  } else if (error.request) {
    return { message: 'NETWORK_ERROR' };
  } else {
    return { message: Errors['UNKNOWN_ERROR'] };
  }
}
</script>

<style lang="scss" scoped>
.app {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &.is-videoresime {
    background: #fafafa;

    @media only screen and (max-width: 1024px) {
      background: #fff;
    }
  }
}
</style>
